export var areas = [{
  abbreviation: "1256859b-650e-42f2-8282-0d3aaac546c9",
  name: "Agricultural/Animal/Plant/Veterinary Science And Related Fields"
}, {
  abbreviation: "7e2f0df0-fd71-4805-9104-981d9c888015",
  name: "Natural Resources And Conservation"
}, {
  abbreviation: "b274ec06-8ec1-4930-92bd-201cd76e49c0",
  name: "Architecture And Related Services"
}, {
  abbreviation: "b1b2d58f-89c6-4800-b79d-c68eb471763f",
  name: "Area, Ethnic, Cultural, Gender, And Group Studies"
}, {
  abbreviation: "c686bca0-ea5d-4c54-9210-db524747052a",
  name: "Communication, Journalism, And Related Programs"
}, {
  abbreviation: "5e5311b5-e68e-4a0d-88f3-daacac1acc04",
  name: "Communications Technologies/Technicians And Support Services"
}, {
  abbreviation: "10b2766b-a6ee-4e8c-9ed4-4c319227b40c",
  name: "Computer And Information Sciences And Support Services"
}, {
  abbreviation: "76d8029f-e09d-4238-af62-129d0c5e17cc",
  name: "Culinary, Entertainment, And Personal Services"
}, {
  abbreviation: "eb4d6be7-3502-4144-bea1-eae0ef43d786",
  name: "Education"
}, {
  abbreviation: "cc04a8ac-1c0b-4915-bad8-89b5d25714fc",
  name: "Engineering"
}, {
  abbreviation: "bedc2e31-9b48-488a-bc38-6680925d8c3e",
  name: "Engineering/Engineering-Related Technologies/Technicians"
}, {
  abbreviation: "a57fe9d9-4aab-432a-974c-03ac571e8862",
  name: "Foreign Languages, Literatures, And Linguistics"
}, {
  abbreviation: "8cfef5f4-5396-4a23-b910-ac506d7902bd",
  name: "Family And Consumer Sciences/Human Sciences"
}, {
  abbreviation: "dd7ef1c5-2d80-45f7-ad06-417e497d7663",
  name: "Legal Professions And Studies"
}, {
  abbreviation: "4feb385b-4781-41b0-91e3-e5a423f04f2e",
  name: "English Language And Literature/Letters"
}, {
  abbreviation: "7c0b8171-f295-4cbc-b2b0-48af03c344b9",
  name: "Liberal Arts And Sciences, General Studies And Humanities"
}, {
  abbreviation: "332c4c3a-cfe3-4282-a352-a00a95bff2ce",
  name: "Library Science"
}, {
  abbreviation: "65cf55b7-0f63-4b24-adc8-ad9eaec16842",
  name: "Biological And Biomedical Sciences"
}, {
  abbreviation: "e4a42678-4e5a-4f6b-b832-f3e3a0c2de7f",
  name: "Mathematics And Statistics"
}, {
  abbreviation: "922fa9dd-1dfc-450e-a74c-be31fa69ee46",
  name: "Military Science, Leadership And Operational Art"
}, {
  abbreviation: "73965178-747d-42cd-9c2a-5bbac6e89318",
  name: "Military Technologies And Applied Sciences"
}, {
  abbreviation: "091f1ada-eae0-4cd6-bcca-7e1a44bb137b",
  name: "Multi/Interdisciplinary Studies"
}, {
  abbreviation: "3c32d81c-1807-4f5a-adc5-c5fc3bf9171a",
  name: "Parks, Recreation, Leisure, Fitness, And Kinesiology"
}, {
  abbreviation: "1d24b00f-1900-4e83-8480-6081d8ee9791",
  name: "Basic Skills And Developmental/Remedial Education"
}, {
  abbreviation: "a186f117-4f89-4cc5-82e6-84b020686b48",
  name: "Citizenship Activities"
}, {
  abbreviation: "441568d3-8a50-4fcf-8d7e-fc7c8302e0c2",
  name: "Health-Related Knowledge And Skills"
}, {
  abbreviation: "295e53a6-94a3-446e-9d60-86436e1bd6da",
  name: "Interpersonal And Social Skills"
}, {
  abbreviation: "cbc2057c-259a-4245-8b6c-b2a9f3288e09",
  name: "Leisure And Recreational Activities"
}, {
  abbreviation: "a864794b-7d06-4b0f-8a02-dba78361e84b",
  name: "Personal Awareness And Self-Improvement"
}, {
  abbreviation: "66ba65b4-a0b1-4777-ad28-88bccca33fc2",
  name: "Philosophy And Religious Studies"
}, {
  abbreviation: "916d4b8c-ea63-4a0c-9a57-4ca1521aa359",
  name: "Theology And Religious Vocations"
}, {
  abbreviation: "efbdada2-69f6-4c38-804c-6e930fa912a5",
  name: "Physical Sciences"
}, {
  abbreviation: "c7b18289-e258-43a9-bce9-ad630831a499",
  name: "Science Technologies/Technicians"
}, {
  abbreviation: "9d5b3d44-d35b-4431-84cd-ba8b6bc13957",
  name: "Psychology"
}, {
  abbreviation: "6ea4aac0-6cef-4d9b-9ed8-829fdfbe1082",
  name: "Homeland Security, Law Enforcement, Firefighting And Related Protective Services"
}, {
  abbreviation: "b9249e91-81a4-4f7c-8673-4a8b3f427ae4",
  name: "Public Administration And Social Service Professions"
}, {
  abbreviation: "9933142b-5fe8-4a3a-8801-ebed12a6d32a",
  name: "Social Sciences"
}, {
  abbreviation: "e436c3a6-cfc4-4e5e-b722-64b64b5540af",
  name: "Construction Trades"
}, {
  abbreviation: "43f66da9-530f-4d21-9687-a59bd23d68ad",
  name: "Mechanic And Repair Technologies/Technicians"
}, {
  abbreviation: "09a6d55b-812e-4f6b-8470-07860ded75b4",
  name: "Precision Production"
}, {
  abbreviation: "50611c92-9c42-47d9-9b1f-b8c56d78ddb6",
  name: "Transportation And Materials Moving"
}, {
  abbreviation: "cb24ddbe-a80a-4bd2-a2a7-92956873af1a",
  name: "Visual And Performing Arts"
}, {
  abbreviation: "44a1b32e-8839-418e-82c6-c4b93b4e6bd6",
  name: "Health Professions And Related Programs"
}, {
  abbreviation: "13598814-f1a8-4443-9497-f454f2f4696d",
  name: "Business, Management, Marketing, And Related Support Services"
}, {
  abbreviation: "80627467-c728-4088-8f31-3ef823478ca6",
  name: "High School/Secondary Diplomas And Certificates"
}, {
  abbreviation: "722cbab2-eb8c-4e50-b9ab-e96d16405339",
  name: "History"
}, {
  abbreviation: "94a43665-22f9-4038-afcb-1f6adb0da1e4",
  name: "Health Professions Residency/Fellowship Programs"
}, {
  abbreviation: "dd846991-18a2-46cc-82d1-a5753dceb5c4",
  name: "Medical Residency/Fellowship Programs"
}];